import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css"; // If you have a CSS file

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);